<template>
  <section>
    <nav class="columns">
      <div class="column">
        <b-field grouped group-multiline>
          <b-field>
            <b-select
              v-model="selectedPage"
              :loading="loadingPageSeo"
              :placeholder="
                $t('message.please_select') + $t('attributes.page_seo_name')
              "
              @input="onSelectedPage"
            >
              <option value="">請選擇頁面</option>
              <option
                v-for="option in pageSeoList"
                :value="option"
                :key="option.id"
              >
                {{ option.name }}
              </option>
            </b-select>
          </b-field>
          <b-field position="is-right">
            <b-button
              class="is-primary"
              icon-left="plus"
              @click="isCreateModalActive = true"
            >
              {{ $t('attributes.add') + $t('attributes.page_seo_name') }}
            </b-button>
          </b-field>
        </b-field>

        <b-tabs
          v-if="!!selectedPage"
          v-model="activeTab"
          :animated="false"
          class="boarder-tabs"
          destroyOnHide
          multiline
          expanded
        >
          <b-tab-item :label="$t('attributes.seo')" :disabled="loading">
            <page-seo :detail="selectedPage" @updated="onUpdated"></page-seo>
          </b-tab-item>
          <b-tab-item
            :label="$t('attributes.page_seo_top_message')"
            :disabled="loading"
          >
            <top-message
              :detail="selectedPage"
              @updated="onUpdated"
            ></top-message>
          </b-tab-item>
        </b-tabs>
      </div>
    </nav>
    <b-modal
      :active.sync="isCreateModalActive"
      :can-cancel="['x']"
      scroll="keep"
      has-modal-card
    >
      <page-seo-create-form :is-sending="sending" @onSend="onCreate" />
    </b-modal>
  </section>
</template>

<script>
import { PAGE_SEO_API } from '@/utils/apis'
import notifyService from '@/services/notifyService'
import PageSeo from '@/components/basic/PageSeo'
import TopMessage from '@/components/basic/TopMessage'
import PageSeoCreateForm from '@/components/basic/PageSeoCreateForm'

export default {
  name: 'PagesSeo',
  components: { PageSeoCreateForm, PageSeo, TopMessage },
  data() {
    return {
      loadingPageSeo: false,
      selectedPage: null,
      pageSeoList: [],
      activeTab: 0,
      loading: false,
      isCreateModalActive: false,
      sending: false
    }
  },
  computed: {},
  mounted() {
    this.loadPageSeo('')
  },
  methods: {
    async loadPageSeo(item) {
      try {
        this.loadingPageSeo = true
        const res = await this.axios.get(PAGE_SEO_API)
        this.pageSeoList = res.data.data
        this.selectedPage = item
      } catch (e) {
        this.pageSeoList = []
        this.selectedPage = null

        notifyService.fetch_error('page_seo_name', e)
      } finally {
        this.loadingPageSeo = false
      }
    },
    onSelectedPage(option) {
      this.selectedPage = option
    },
    onUpdated(item) {
      if (item) {
        this.loadPageSeo(item)
      }
    },
    async onCreate(item) {
      try {
        const api = `${PAGE_SEO_API}/create`
        this.sending = true
        await this.axios.post(api, item)

        this.isCreateModalActive = false

        notifyService.success(this.$t('attributes.add_succeed'))
        await this.loadPageSeo('')
      } catch (e) {
        notifyService.create_error(e)
      } finally {
        this.sending = false
      }
    }
  }
}
</script>
